import { handleError } from '../../core/hook/utils'
import { DefaultStoreCode, findStoreByLocaleOrPrefix } from '../../domain/store'

export const getDayOfWeekFromDate = (date: Date) => {
  const daysOfWeek = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi']
  const day = date.getDay()
  return daysOfWeek[day]
}

export const getMonthFromDate = (date: Date) => {
  const monthsOfYear = [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
  ]
  const month = date.getMonth()
  return monthsOfYear[month]
}

export const localeDate = (date: Date, storeCode: string): string => {
  const store = findStoreByLocaleOrPrefix(storeCode)
  try {
    return date.toLocaleDateString(store?.locale, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  } catch (error) {
    handleError(error, false)

    return date.toLocaleDateString(DefaultStoreCode, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }
}
